// cspell:disable
/* eslint-disable */
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
// import UploadOptions from "./uploadOptions/index";
import FilesWrapper from "./FilesWrapper/index";
// import useTheme from "hooks/observer";
import { File as IzFile, Folder as IzFolder } from "@induz/sdk";
import StorageFail from "./storageFail/index";
import UploadOptions from "./uploadOptions/index";
import { useToast } from "components/Toaster/index";
import TaskMonitor from "./TaskMonitor/index";
import { Share } from "@induz/sdk";// import { format } from "prettier";
import "./Ysafe.scss";
import useScreenMobile from "../../../hooks/useScreen";
import { normalizeName } from "utils/normalizeName";

function Ysafe({ taskManager, searchQuery, sortSelected, isSortRotated, setIsSortRotated, layout, setLayout, showSharedTab = true, backendOperations, isOrganisationUser, hasSpacePermission = true }) {
  const isMobile = useScreenMobile({ size: 992 });
  const itemsPerPage = isMobile ? 20 : 50;
  // const [show, setShow] = useState(false);
  const [filesList, setFilesList] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [progress, setProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [cancelUploadModal, setCancelUploadModal] = useState(false);
  const [showLoadingProgress, setShowLoadingProgress] = useState(false);
  const [uploadFolder, setUploadFolder] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [fetching, setFetching] = useState(false);
  const [showListingLoader, setShowListingLoader] = useState(false);
  const loaderShowDelayTimeoutRef = useRef(null);
  const loaderHideTimeoutRef = useRef(null);
  const loaderVisibleSinceRef = useRef(0);


  const [UUIDArrays, setUUIDArrays] = useState([]);

  const [filesData, setFilesData] = useState([]); // Stores the fetched files/folders
  const [length, setLength] = useState(0);
  const [currentPath, setCurrentPath] = useState([]); // Stores folder navigation path
  const [checkedRows, setCheckedRows] = useState({});
  const [showingSection, setShowingSection] = useState(0); // Stores section names
  const [namesArrays, setNamesArrays] = useState();
  const [typesArrays, setTypesArrays] = useState();
  const [sizeArrays, setSizeArrays] = useState();
  const [modifiedArrays, setModifiedArrays] = useState();
  const [ownerArrays, setOwnerArrays] = useState();
  const [show, setShow] = useState(false);
  const [showUploadOptionsArr, setShowUploadOptionsArr] = useState([]);
  const childFuntionRef = useRef(null);
  const listedFolders = useRef(null);
  const showToast = useToast();

  const totalPages = useRef(1);
  const pageHistoryRef = useRef({});

  const addToLength = (n) => {
    setLength(prev => prev + n);
  };

  const convertUTCToLocal = (dateString) => {
    if (!dateString) return "";

    const isoUTC = dateString.replace(" ", "T") + "Z";

    const d = new Date(isoUTC);
    if (isNaN(d.getTime())) return dateString;

    // Format using the user's current locale + timezone
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };

    // Example output: "2025-11-27 18:42:10"
    const formatted = d.toLocaleString(undefined, options);

    // Standardize separators
    return formatted.replace(",", "");
  };

  function random4CharsString() {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    try {
      const arr = new Uint8Array(4);
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        crypto.getRandomValues(arr);
      } else {
        arr.forEach((_, i) => (arr[i] = Math.floor(Math.random() * 256)));
      }
      for (let i = 0; i < 4; i++) {
        result += chars[arr[i] % chars.length];
      }
    } catch {
      for (let i = 0; i < 4; i++) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
    }
    return result;
  }

  function getNewName(srcname) {
    // First, normalize the source name to ensure consistency with existing files
    const normalizedSrc = normalizeName(srcname, true);

    const lastDot = normalizedSrc.lastIndexOf(".");
    const extension = lastDot !== -1 ? normalizedSrc.slice(lastDot) : "";
    let name = lastDot !== -1 ? normalizedSrc.slice(0, lastDot) : normalizedSrc;

    const randomString = random4CharsString();

    const maxLength = 80;
    const suffix = "_" + randomString + extension;
    const availableLength = Math.max(0, maxLength - suffix.length);

    if (name.length > availableLength) {
      name = name.slice(0, availableLength);
    }

    // Clean up trailing underscores before attaching suffix
    name = name.replace(/_+$/g, "");

    return name + suffix;
  }
  // have to refine this funtionality
  const keepTheCopyFiles = () => {
    let tempArr = [...selectedFile];
    showUploadOptionsArr.forEach((conflictFile) => {
      const index = tempArr.findIndex((data) => data.name === conflictFile.name);





      if (index !== -1) {
        const originalFile = tempArr[index];
        const newName = getNewName(originalFile.name);
        // Create new file from original to preserve properties/metadata
        const newFile = new File([originalFile], newName, { type: originalFile.type });

        // Preserve webkitRelativePath for folder structure preservation
        if (originalFile.webkitRelativePath) {
          Object.defineProperty(newFile, 'webkitRelativePath', {
            value: originalFile.webkitRelativePath,
            writable: false,
          });
        }

        tempArr[index] = newFile;
      }

    });
    if (childFuntionRef.current) {
      childFuntionRef.current?.saveHandler(tempArr);
      setShowUploadOptionsArr([]);
    }
  };

  const replaceExistingFiles = async () => {
    try {
      const sourcePath = currentPath.join("/");
      const folderPathArr = [];
      showUploadOptionsArr.forEach((data) => {
        folderPathArr.push(
          (sourcePath.length !== 0 ? "/" : "") + sourcePath + "/" + data.name
        );
      });

      // console.log(promiseRes, "promiseRes");
      if (childFuntionRef.current) {
        childFuntionRef.current?.saveHandler(showUploadOptionsArr);
        setShowUploadOptionsArr([]);
      }
    } catch (error) {
      // console.log("promiseRes : ", error);
      showToast(error.message, "error");
    }
  };

  const onUploadPress = (choosenOptionNumber) => {
    if (choosenOptionNumber === 0) {
      replaceExistingFiles();
    } else if (choosenOptionNumber === 1) {
      keepTheCopyFiles();
    }
  };

  const showUplodOptionsFunciton = (filesArray) => {
    setShowUploadOptionsArr(filesArray);
  };


  const getReanderingList = (list) => {
    const names = [];
    const types = [];
    const size = [];
    const modifiedDate = [];
    const owner = [];
    const uuids = [];
    list.forEach((data) => {
      if (data instanceof IzFolder) {
        types.push("folder");
        names.push(data.getFolderName());
        size.push("");
        modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
        owner.push(data.getOwner());
        uuids.push(data.getUuId());
      } else if (data instanceof IzFile) {
        names.push(data.getName());
        types.push("file");
        size.push(data.getSizeString());
        modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
        owner.push(data.getOwner());
        uuids.push(data.getFileUuId());
      } else {
        types.push("unknown");
      }
    });
    setNamesArrays(names);
    setTypesArrays(types);
    setSizeArrays(size);
    setModifiedArrays(modifiedDate);
    setOwnerArrays(owner);
    setUUIDArrays(uuids);
    setFilesData(list);
  };

  const fetchTrashedFiles = async (formattedPath) => {
    try {
      const folder = new IzFolder();
      folder.pageSize = itemsPerPage;
      folder.setInTrash(true);
      const list = await folder.getFolderList();
      setCurrentPage(1);
      listedFolders.current = (folder);
      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];
      const uuids = [];

      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          // size.push(data.get_size());
          size.push("");
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          // owner.push("Induz");
          owner.push(data.getOwner());
          uuids.push(data.getUuId());
        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          owner.push(data.getOwner());
          uuids.push(data.getFileUuId());
        } else {
          types.push("unknown"); // Fallback if needed
        }
      });
      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setUUIDArrays(uuids);
      setFilesData(list);
      addToLength(names.length);
      setSelectedFile([]);

      const savedPage = pageHistoryRef.current[formattedPath] || 1;
      let finalPage = 1;
      if (savedPage > 1) {
        let currentList = list;
        for (let p = 1; p < savedPage; p++) {
          try {
            currentList = await folder.getNextFolderList(p);
            finalPage = p + 1;
          } catch (e) {
            break;
          }
        }
        if (finalPage > 1) {
          processSharedList(currentList); // Update the arrays with the correct page list
        }
      }
      setCurrentPage(finalPage);

    } catch (error) {
      console.error("This is the error::", error);
    }
  };

  const fetchRecentFiles = async (formattedPath) => {
    setFetching(true);
    try {
      let folder;
      if (formattedPath === "/" || formattedPath === "") {
        const fo = new IzFolder();
        fo.pageSize = itemsPerPage;
        folder = fo.getRoot();
        folder.pageSize = itemsPerPage;
      } else {
        // get last folder name
        const fo = new IzFolder();
        fo.pageSize = itemsPerPage;
        folder = fo.folderWithName(formattedPath);
        folder.pageSize = itemsPerPage;
      }
      const list = await folder.getFolderList(0);
      setCurrentPage(1);
      listedFolders.current = (folder);

      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];


      const uuids = [];

      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          size.push("");
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          owner.push(data.getOwner());
          uuids.push(data.getUuId());
        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          owner.push(data.getOwner());
          uuids.push(data.getFileUuId());
        } else {
          types.push("unknown");
        }
      });
      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setUUIDArrays(uuids);
      setFilesData(list);
      addToLength(names.length);
      setSelectedFile([]);

      const savedPage = pageHistoryRef.current[formattedPath] || 1;
      let finalPage = 1;
      if (savedPage > 1) {
        let currentList = list;
        for (let p = 1; p < savedPage; p++) {
          try {
            currentList = await folder.getNextFolderList(p);
            finalPage = p + 1;
          } catch (e) { break; }
        }
        if (finalPage > 1) {
          // Re-run population for the new list
          const names2 = [], types2 = [], size2 = [], modifiedDate2 = [], owner2 = [], uuids2 = [];
          currentList.forEach((data) => {
            if (data instanceof IzFolder) {
              types2.push("folder"); names2.push(data.getFolderName()); size2.push("");
              modifiedDate2.push(convertUTCToLocal(data.getLastModifiedDateString())); owner2.push(data.getOwner()); uuids2.push(data.getUuId());
            } else if (data instanceof IzFile) {
              names2.push(data.getName()); types2.push("file"); size2.push(data.getSizeString());
              modifiedDate2.push(convertUTCToLocal(data.getLastModifiedDateString())); owner2.push(data.getOwner()); uuids2.push(data.getFileUuId());
            } else { types2.push("unknown"); }
          });
          setNamesArrays(names2); setTypesArrays(types2); setSizeArrays(size2); setModifiedArrays(modifiedDate2); setOwnerArrays(owner2);
          setUUIDArrays(uuids2); setFilesData(currentList);
        }
      }
      setCurrentPage(finalPage);

    } catch (error) {
      console.error("This is the error::", error);
    } finally {
      setFetching(false);
    }
  };

  const fetchAllFiles = async (formattedPath, selected) => {
    try {
      let folder;
      if (formattedPath === "/" || formattedPath === "") {
        const fo = new IzFolder();
        fo.pageSize = itemsPerPage;
        folder = fo.getRoot();
        folder.pageSize = itemsPerPage;
      } else {
        // get last folder name
        const fo = new IzFolder();
        fo.pageSize = itemsPerPage;
        folder = fo.folderWithName(formattedPath);
        folder.pageSize = itemsPerPage;
      }
      let list = [];
      if (selected === "Name") {
        list = await folder.getFolderList(2);
        setCurrentPage(1);
      } else if (selected === "Modified Date") {
        list = await folder.getFolderList(0);
        setCurrentPage(1);
      } else if (selected === "File Size") {
        list = await folder.getFolderList(3);
        setCurrentPage(1);
        // console.log("came here");
      } else if (selected === "Created Date") {
        list = await folder.getFolderList(1);
        setCurrentPage(1);
      } else {
        list = await folder.getFolderList(1);
        setCurrentPage(1);
      }
      listedFolders.current = (folder);
      const names = [];
      const types = [];
      const size = [];
      const modifiedDate = [];
      const owner = [];
      const uuids = [];
      list.forEach((data) => {
        if (data instanceof IzFolder) {
          types.push("folder");
          names.push(data.getFolderName());
          size.push("");
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          owner.push(data.getOwner());
          uuids.push(data.getUuId());
        } else if (data instanceof IzFile) {
          names.push(data.getName());
          types.push("file");
          size.push(data.getSizeString());
          modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
          owner.push(data.getOwner());
          uuids.push(data.getFileUuId());
        } else {
          types.push("unknown");
        }
      });

      setNamesArrays(names);
      setTypesArrays(types);
      setSizeArrays(size);
      setModifiedArrays(modifiedDate);
      setOwnerArrays(owner);
      setUUIDArrays(uuids);
      setFilesData(list);
      addToLength(names.length);

      setSelectedFile([]);

      const savedPage = pageHistoryRef.current[formattedPath] || 1;
      let finalPage = 1;
      if (savedPage > 1) {
        let currentList = list;
        for (let p = 1; p < savedPage; p++) {
          try {
            currentList = await folder.getNextFolderList(p);
            finalPage = p + 1;
          } catch (e) { break; }
        }
        if (finalPage > 1) {
          const names2 = [], types2 = [], size2 = [], modifiedDate2 = [], owner2 = [], uuids2 = [];
          currentList.forEach((data) => {
            if (data instanceof IzFolder) {
              types2.push("folder"); names2.push(data.getFolderName()); size2.push("");
              modifiedDate2.push(convertUTCToLocal(data.getLastModifiedDateString())); owner2.push(data.getOwner()); uuids2.push(data.getUuId());
            } else if (data instanceof IzFile) {
              names2.push(data.getName()); types2.push("file"); size2.push(data.getSizeString());
              modifiedDate2.push(convertUTCToLocal(data.getLastModifiedDateString())); owner2.push(data.getOwner()); uuids2.push(data.getFileUuId());
            } else { types2.push("unknown"); }
          });
          setNamesArrays(names2); setTypesArrays(types2); setSizeArrays(size2); setModifiedArrays(modifiedDate2); setOwnerArrays(owner2);
          setUUIDArrays(uuids2); setFilesData(currentList);
        }
      }
      setCurrentPage(finalPage);

    } catch (error) {
      console.error("This is the error::", error);
    }
  };

  const fetchFavorites = async (formattedPath) => {
    // Favorites functionality is not implemented yet
    // try {
    //   await init();

    //   let folder;
    //   if (formattedPath === "/") {
    //     folder = Folder.get_root();
    //   } else if (formattedPath === "") {
    //     folder = Folder.get_root();
    //   } else {
    //     // get last folder name
    //     folder = await Folder.folder_with_name(formattedPath);
    //   }
    //   const list = await folder.folder_list(2);

    //   const names = [];
    //   const types = [];


    //   list.forEach((data) => {

    //     if (data instanceof Folder) {
    //       types.push("folder");
    //       names.push(data.get_path());
    //     } else if (data instanceof IzFile) {
    //       names.push(data.get_name());
    //       types.push("file");

    //     } else {
    //       types.push("unknown"); // Fallback if needed
    //     }
    //   });

    //   setNamesArrays(names);
    //   setTypesArrays(types);
    //   setFilesData(list);
    //   addToLength(names.length);
    //   setSelectedFile([]);
    // } catch (error) {
    //   console.error("This is the error::", error);
    // }
  };

  const fetchSharedFiles = async (formattedPath) => {
    try {

      // console.log("formattedpath", formattedPath);
      // console.log("currentPath", currentPath);

      const pathParts = formattedPath.split("/").filter(Boolean);
      // console.log("Path parts:", pathParts);
      if (formattedPath === "/shared") {

        // console.log("/shared");
        let share = new Share("", "");
        const teams = await share.listTeamOfUsers();

        // console.log("Teams",teams);
        const teamUUIDs = teams.map(team => team.uuid || team.id || ""); // Adjust key as per actual team object
        const teamNames = teams.map(team => ({
          value: team.name || team, // Adjust based on actual team object structure
          label: team.name || team,
        }));
        const finalTeamNames = teamNames.map(team => team.value);
        setNamesArrays(["self", ...finalTeamNames]);
        setUUIDArrays(["self", ...teamUUIDs]);
        const types = ["folder", ...finalTeamNames.map(() => "folder")];
        const sizes = ["", ...finalTeamNames.map(() => "")];
        const modifiedDates = ["", ...finalTeamNames.map(() => "")];
        const owners = ["", ...finalTeamNames.map(() => "")];
        setTypesArrays(types);
        setSizeArrays(sizes);
        setModifiedArrays(modifiedDates);
        setOwnerArrays(owners);
        setFilesData([]);
      } else if (formattedPath === "/shared/self") {
        // console.log("Inside root self");
        let selffolder = new IzFolder();
        selffolder.pageSize = itemsPerPage;
        selffolder.parentPath = "/shared";
        selffolder.folderName = "";
        listedFolders.current = (selffolder);
        processSharedList(await selffolder.getSharedWithMeFolderList(false));
      } else if (pathParts.length == 2) {
        let selffolder = new IzFolder();
        selffolder.pageSize = itemsPerPage;
        let teamName = pathParts[1];
        selffolder.parentPath = `/shared/teams`;
        // console.log("Self.parentpath", selffolder.parentPath);
        selffolder.folderName = teamName;
        listedFolders.current = (selffolder);
        processSharedList(await selffolder.getSharedWithMeFolderList(true));

      } else if (formattedPath.startsWith("/shared/teams/")) {
        // console.log("inside team subfolder");
        const newPath = [...currentPath];
        newPath.splice(1, 1);
        setCurrentPath(newPath);
      }
      else {

        if (currentPath[1] === "self") {
          // console.log("Inside self");
          const newPath = [...currentPath];
          newPath.splice(1, 1);
          const joinedPath = newPath.join("/");
          // console.log("Joined path", joinedPath);

          let fo = new IzFolder();
          fo.pageSize = itemsPerPage;
          let folder = fo.folderWithName(joinedPath);
          folder.pageSize = itemsPerPage;
          listedFolders.current = (folder);
          processSharedList(await folder.getSharedWithMeFolderList(false));
        }

        else {
          // console.log("e");
          const newPath = [...currentPath];
          newPath.splice(1, 1);
          const joinedPath = newPath.join("/");
          let fo = new IzFolder();
          fo.pageSize = itemsPerPage;
          let folder = fo.folderWithName(joinedPath);
          folder.pageSize = itemsPerPage;
          listedFolders.current = (folder);
          processSharedList(await folder.getSharedWithMeFolderList(false));
        }

      }

      const savedPage = pageHistoryRef.current[formattedPath] || 1;
      let finalPage = 1;
      if (savedPage > 1) {
        let currentList = [];
        for (let p = 1; p < savedPage; p++) {
          try {
            currentList = await listedFolders.current.getNextFolderList(p);
            finalPage = p + 1;
          } catch (e) { break; }
        }
        if (finalPage > 1) {
          processSharedList(currentList);
        }
      }
      setCurrentPage(finalPage);

    } catch (error) {
      // Handle errors, maybe show a message
      console.error("Error fetching shared files:", error);
      showToast("Failed to fetch shared", "error");
    }
  };

  // Helper function to process shared files/folders
  function processSharedList(list) {
    const names = [];
    const types = [];
    const size = [];
    const modifiedDate = [];
    const owner = [];
    const uuids = [];
    list.forEach((data) => {
      if (data instanceof IzFolder) {
        types.push("folder");
        names.push(data.getFolderName());
        size.push("");
        modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
        owner.push(data.getOwner());
        uuids.push(data.getUuId());
      } else if (data instanceof IzFile) {
        names.push(data.getName());
        types.push("file");
        size.push(data.getSizeString());
        modifiedDate.push(convertUTCToLocal(data.getLastModifiedDateString()));
        owner.push(data.getOwner());
        uuids.push(data.getFileUuId());
      } else {
        types.push("unknown");
      }
    });
    setNamesArrays(names);
    setTypesArrays(types);
    setSizeArrays(size);
    setModifiedArrays(modifiedDate);
    setOwnerArrays(owner);
    setFilesData(list);
    addToLength(names.length);
    setSelectedFile([]);
    setUUIDArrays(uuids);
  }

  const fetchData = async (path = [], selected) => {
    setFetching(true);
    try {
      setCheckedRows({});
      setNamesArrays([]);
      setTypesArrays([]);
      setSizeArrays([]);
      setModifiedArrays([]);
      setOwnerArrays([]);
      setUUIDArrays([]);
      setFilesData([]);
      let formattedPath = path?.length === 0 ? "/" : `/${path?.join("/")}`;
      // const url = URL;
      // const sdk = new Sdk(url);
      if (path.length === 0 && showingSection + 1 === 2) {
        formattedPath = "/shared";
      }

      if (showingSection === 0) {
        await fetchAllFiles(formattedPath, selected);
      } else if (showingSection === 1) {
        await fetchSharedFiles(formattedPath);
      } else if (showingSection === 2) {
        await fetchTrashedFiles(formattedPath);
      }
      totalPages.current = (listedFolders.current ? Math.ceil(listedFolders.current.getTotalItems() / listedFolders.current.getPageSize()) : 1);
    } catch (error) {

      showToast(error.message, "error");
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    totalPages.current = (listedFolders.current ? Math.ceil(listedFolders.current.getTotalItems() / listedFolders.current.getPageSize()) : 1);
  }, [listedFolders.current]);

  useLayoutEffect(() => {
    // Clear data synchronously when path or section changes to avoid "glimpse" of old data
    setCheckedRows({});
    setNamesArrays([]);
    setTypesArrays([]);
    setSizeArrays([]);
    setModifiedArrays([]);
    setOwnerArrays([]);
    setUUIDArrays([]);
    setFilesData([]);
    // Reset listedFolders and pagination to prevent stale data mismatch
    listedFolders.current = null;
    totalPages.current = 1;
    setCurrentPage(1);
  }, [currentPath, showingSection]);

  useEffect(() => {
    fetchData(currentPath);
  }, [currentPath, showingSection]);

  const [TaskMonitorVisible, setTaskMonitorVisible] = useState(false);

  // Listen for toggle event from homepage header button
  useEffect(() => {
    const handleToggleOperationPanel = () => {
      setTaskMonitorVisible((prev) => !prev);
    };

    document.addEventListener("toggleOperationPanel", handleToggleOperationPanel);
    return () => {
      document.removeEventListener("toggleOperationPanel", handleToggleOperationPanel);
    };
  }, []);

  // Listen for navigation from advanced search modal
  useEffect(() => {
    const handleAdvSearchNavigate = (e) => {
      const newPath = e.detail; // array of path parts
      if (Array.isArray(newPath)) {
        setCurrentPath(newPath);
      }
    };
    window.addEventListener("advSearchNavigate", handleAdvSearchNavigate);
    return () => window.removeEventListener("advSearchNavigate", handleAdvSearchNavigate);
  }, []);

  useEffect(() => {
    const LOADER_SHOW_DELAY_MS = 150;
    const LOADER_MIN_VISIBLE_MS = 250;

    if (fetching) {
      if (loaderHideTimeoutRef.current) {
        clearTimeout(loaderHideTimeoutRef.current);
        loaderHideTimeoutRef.current = null;
      }

      if (!showListingLoader && !loaderShowDelayTimeoutRef.current) {
        loaderShowDelayTimeoutRef.current = setTimeout(() => {
          setShowListingLoader(true);
          loaderVisibleSinceRef.current = Date.now();
          loaderShowDelayTimeoutRef.current = null;
        }, LOADER_SHOW_DELAY_MS);
      }
      return;
    }

    if (loaderShowDelayTimeoutRef.current) {
      clearTimeout(loaderShowDelayTimeoutRef.current);
      loaderShowDelayTimeoutRef.current = null;
    }

    if (showListingLoader) {
      const visibleFor = Date.now() - loaderVisibleSinceRef.current;
      const remainingVisibleMs = Math.max(0, LOADER_MIN_VISIBLE_MS - visibleFor);
      loaderHideTimeoutRef.current = setTimeout(() => {
        setShowListingLoader(false);
        loaderHideTimeoutRef.current = null;
      }, remainingVisibleMs);
    }
  }, [fetching, showListingLoader]);

  useEffect(() => {
    return () => {
      if (loaderShowDelayTimeoutRef.current) {
        clearTimeout(loaderShowDelayTimeoutRef.current);
      }
      if (loaderHideTimeoutRef.current) {
        clearTimeout(loaderHideTimeoutRef.current);
      }
    };
  }, []);

  // Refresh data when advanced search modal is closed
  useEffect(() => {
    const handleAdvSearchClosed = () => {
      fetchData(currentPath);
    };
    window.addEventListener("advSearchClosed", handleAdvSearchClosed);
    return () => window.removeEventListener("advSearchClosed", handleAdvSearchClosed);
  }, [currentPath]);

  // Clear page history explicitly when tabs change to avoid restoring a saved page
  useEffect(() => {
    const handleTabChanged = () => {
      pageHistoryRef.current = {};
    };
    window.addEventListener("filesTabChanged", handleTabChanged);
    return () => window.removeEventListener("filesTabChanged", handleTabChanged);
  }, []);

  return (
    <>
      <TaskMonitor
        taskManager={taskManager}
        TaskMonitorVisible={TaskMonitorVisible}
        setTaskMonitorVisible={setTaskMonitorVisible}
      />
      <div className="tableWithPage">
        {showListingLoader && (
          <div className="listingLoaderOverlay">
            <div className="listingLoader">
              <span className="listingLoaderSpinner" />
              Loading files and folders...
            </div>
          </div>
        )}
        <FilesWrapper
          TaskMonitorVisible={TaskMonitorVisible}
          setTaskMonitorVisible={setTaskMonitorVisible}
          folder={listedFolders.current}
          ref={childFuntionRef}
          setShow={setShow}
          checkedRows={checkedRows}
          setCheckedRows={setCheckedRows}
          filesList={filesList}
          setFilesList={setFilesList}
          modal={modal}
          setModal={setModal}
          uploadModal={uploadModal}
          setUploadModal={setUploadModal}
          setUploadedFiles={setUploadedFiles}
          uploadedFiles={uploadedFiles}
          setIsDropDownVisible={setIsDropDownVisible}
          isDropDownVisible={isDropDownVisible}
          setCancelUploadModal={setCancelUploadModal}
          cancelUploadModal={cancelUploadModal}
          setShowLoadingProgress={setShowLoadingProgress}
          showLoadingProgress={showLoadingProgress}
          fetchData={fetchData}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          progress={progress}
          setProgress={setProgress}
          timeRemaining={timeRemaining}
          setTimeRemaining={setTimeRemaining}
          data={filesData}
          setCurrentPath={setCurrentPath}
          currentPath={currentPath}
          path={currentPath}
          namesArrays={namesArrays}
          typesArrays={typesArrays}
          sizeArrays={sizeArrays}
          modifiedArrays={modifiedArrays}
          ownerArrays={ownerArrays}
          setShowingSection={setShowingSection}
          showUplodOptionsFunciton={showUplodOptionsFunciton}
          setUploadFolder={setUploadFolder}
          uploadFolder={uploadFolder}
          UUIDArrays={UUIDArrays}
          taskManager={taskManager}
          searchQuery={searchQuery}
          sortSelected={sortSelected}
          isSortRotated={isSortRotated}
          setIsSortRotated={setIsSortRotated}
          layout={layout}
          setLayout={setLayout}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          listedFolders={listedFolders.current}
          getReanderingList={getReanderingList}
          showSharedTab={showSharedTab}
          itemsPerPage={itemsPerPage}
          backendOperations={backendOperations}
          isOrganisationUser={isOrganisationUser}
          hasSpacePermission={hasSpacePermission}
        />
        {/* Add 'trash-pagination' class only when in Trash section (showingSection + 1 === 3) to apply -27px margin-top for better visibility */}
        {filesData.length > 0 && !(checkedRows && Object.keys(checkedRows).length != 0) && (
          <div className={`tabletest-pagination-wrapper ${showingSection + 1 === 3 ? 'trash-pagination' : ''}`}>
            <div className="tabletest-pagination-info">
              {(() => {
                const currentItemsPerPage = listedFolders.current ? listedFolders.current.getPageSize() : itemsPerPage;
                // Calculate total items: if on last page, use actual count, otherwise estimate
                const totalItems = listedFolders.current
                  ? listedFolders.current.getTotalItems()
                  : filesData.length;
                totalPages.current = Math.ceil(totalItems / currentItemsPerPage);
                const startItem = (currentPage - 1) * currentItemsPerPage + 1;
                const endItemExp = currentPage === totalPages.current
                  ? (totalPages.current - 1) * currentItemsPerPage + filesData.length
                  : currentPage * currentItemsPerPage;
                const endItem = Math.min(endItemExp, totalItems);
                return `Showing ${startItem} to ${endItem} of ${totalItems} results`;
              })()}
            </div>
            <div className="tabletest-pagination-controls">
              <span className="tabletest-pagination-page-info">
                Page {currentPage} of {totalPages.current}
              </span>
              <div className="tabletest-pagination-arrows">
                <button
                  className="tabletest-pagination-arrow-btn"
                  onClick={async () => {
                    if (listedFolders.current && getReanderingList) {
                      setFetching(true);
                      const list = await listedFolders.current.getPreviousFolderList(currentPage - 1);
                      setFetching(false);
                      const newPage = Math.max(currentPage - 1, 1);
                      setCurrentPage(newPage);
                      let formattedPath = currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
                      if (showingSection + 1 === 2 && currentPath.length === 0) formattedPath = "/shared";
                      pageHistoryRef.current[formattedPath] = newPage;
                      getReanderingList(list);
                    }
                  }}
                  disabled={fetching || currentPage === 1 || !listedFolders.current}
                  aria-label="Previous page"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Previous">
                    <path d="M15 6l-6 6 6 6" fill="none" stroke="darkViolet" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>

                </button>
                <button
                  className="tabletest-pagination-arrow-btn"
                  id="enter-test"
                  onClick={async () => {
                    if (listedFolders.current && getReanderingList) {
                      setFetching(true);
                      const list = await listedFolders.current.getNextFolderList(currentPage);
                      setFetching(false);
                      const newPage = Math.max(currentPage + 1, 1);
                      setCurrentPage(newPage);
                      let formattedPath = currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
                      if (showingSection + 1 === 2 && currentPath.length === 0) formattedPath = "/shared";
                      pageHistoryRef.current[formattedPath] = newPage;
                      getReanderingList(list);
                    }
                  }}
                  disabled={fetching || currentPage === totalPages.current || !listedFolders.current}
                  aria-label="Next page"
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" role="img" aria-label="Next">
                    <path d="M9 6l6 6-6 6" fill="none" stroke="darkViolet" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {show && (
        <StorageFail isVisible={show} handleCancel={() => setShow(false)} />
      )}
      {/* <FilesWrapper /> */}
      {showUploadOptionsArr.length !== 0 && (
        <UploadOptions
          onCancelPress={() => {
            setShowUploadOptionsArr([]);
          }}
          showUploadOptionsArr={showUploadOptionsArr}
          onUploadPress={onUploadPress}
        />
      )}
    </>
  );
}

export default memo(Ysafe);
